import { css } from "@vitality-ds/system";
import { colorUseCases, getColorScaleValueByUseCase } from "@vitality-ds/tokens";
var text = colorUseCases.text;
// eslint-disable-next-line import/prefer-default-export
export var BaseIconWrapper = css({
  svg: {
    marginTop: "unset",
    $$size: "1rem",
    height: "$$size",
    width: "$$size",
    color: getColorScaleValueByUseCase("neutral", text.lowContrast),
    verticalAlign: "text-top"
  }
});